import { eventsSender, eventsSenderYandex } from 'globalState/global-state.js';

export const openCheckout = ({ isMobile }) => {
    try {
        eventsSenderYandex('checkout', 'openCheckout', {
            summ: window.cartParam.summ,
            weight: window.cartParam.weight,
            dimensions: window.cartParam.dimensions,
            split: window.config.state.split,
            geo: isMobile
                ? document
                      .querySelector('.auth .select-geo-btn')
                      .innerText.trim()
                : document.querySelector('#page-header .city').innerText.trim(),
        });

        if (window.dataLayer) {
            window.dataLayer.push({
                event: 'view_cart',
                ecommerce: {
                    currencyCode: 'RUB',
                },
            });
        }
    } catch (error) {
        console.error(error);
    }
};

export const showCheckoutForm = () => {
    if (window.dataLayer) {
        window.dataLayer.push({
            event: 'begin_checkout',
            ecommerce: {
                currencyCode: 'RUB',
            },
        });
    }
};

export const selectedPayment = ({ sid }) => {
    try {
        eventsSender('checkout', 'selectPayMethod', sid);
    } catch (error) {
        console.error(error);
    }
};

export const selectedDelivery = (params) => {
    try {
        eventsSender('checkout', 'selectDeliveryMethod', params);
    } catch (error) {
        console.error(error);
    }
};

export const selectPickupPoint = (params) => {
    try {
        if (params.deliveryType === 'ourpoint') {
            eventsSender('checkout', 'setDeliveryOurpoint', {
                ourpoint: params.point,
            });
        } else {
            eventsSender('checkout', 'setDeliveryPoint', {
                outpoint: params.point,
            });
        }
    } catch (error) {
        console.error(error);
    }
};

export const clickMapPoint = () => {
    try {
        eventsSender('checkout', 'clickMapPoint');
    } catch (error) {
        console.error(error);
    }
};

export const openPickupMap = (params) => {
    try {
        eventsSender('checkout', 'openMap', {
            ...params,
            deliveryType: 'outpoint',
        });
        ym(17186719, 'reachGoal', 'openMap');
    } catch (error) {
        console.error(error);
    }
};

export const openDeliveryMap = (params) => {
    try {
        eventsSender('checkout', 'openMap', {
            ...params,
            deliveryType: 'currier',
        });
        ym(17186719, 'reachGoal', 'openMap');
    } catch (error) {
        console.error(error);
    }
};

export const setDeliveryVariant = (params) => {
    try {
        eventsSender('checkout', 'setDeliveryVariant', params);
    } catch (error) {
        console.error(error);
    }
};

export const sendNewOrder = (params) => {
    try {
        eventsSenderYandex('checkout', 'sendNewOrder', {
            ...params,
            split: window.config.state.split,
        });

        if (params.isFirstOrder) {
            //** @todo исправить счетчик для метрики везде, в переменную */
            ym(17186719, 'reachGoal', 'new_checout');
        }

        if (params.orderSend && window.dataLayer) {
            window.dataLayer.push({
                ecommerce: {
                    currencyCode: 'RUB',
                    purchase: {
                        actionField: {
                            id: params.orderId,
                        },
                        products: params.products,
                    },
                },
            });

            window.dataLayer.push({
                event: 'purchase',
                ecommerce: {
                    currencyCode: 'RUB',
                    actionField: {
                        id: params.orderId,
                    },
                    products: params.products,
                },
            });
        }
    } catch (error) {
        console.error(error);
    }
};

export const loadingLastInfo = (params) => {
    try {
        eventsSender('checkout', 'loadingLastInfo', params);
    } catch (error) {
        console.error(error);
    }
};

export const loadingDeliveries = (params) => {
    try {
        eventsSender('checkout', 'loadingDeliveries', params);
    } catch (error) {
        console.error(error);
    }
};

export const handleToOldCheckout = () => {
    eventsSender('checkout', 'clickToOldCheckout');
};
